/**
 * Custom transport for rpc-anywhere that works with React Native WebView
 * This is the Web (WebView) side of the transport.
 */

import type { RPCTransport } from "rpc-anywhere";

const RPC_MESSAGE_PREFIX = "__RPC_ANYWHERE__";

declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void;
    };
    __lemmonRPCBridge?: {
      handleMessage: (data: any) => void;
    };
  }
}

export function createWebViewTransport(): RPCTransport & { dispose: Function } {
  let handler: ((data: any) => void) | null = null;

  // Set up global handler for messages from React Native (via injectJavaScript)
  window.__lemmonRPCBridge = {
    handleMessage(data: any) {
      if (handler) {
        handler(data);
      }
    },
  };

  return {
    send(data: any): void {
      if (window.ReactNativeWebView) {
        const message = JSON.stringify({
          __rpc: RPC_MESSAGE_PREFIX,
          data,
        });
        window.ReactNativeWebView.postMessage(message);
      } else {
        console.warn(
          "ReactNativeWebView not available, cannot send RPC message",
        );
      }
    },

    registerHandler(h: (data: any) => void): void {
      handler = h;
    },

    unregisterHandler(): void {
      handler = null;
    },

    // Cleanup
    dispose(): void {
      delete window.__lemmonRPCBridge;
      handler = null;
    },
  };
}
